import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Organization } from "@models/organization.model";
import { User } from "@models/user.model";
import { map, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserAdminService {
  private apiUrl = environment.apiUrl;

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.apiUrl}/Users`);
  }
  addUser(newUser: User): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}/Users`, newUser);
  }

  updateUser(newUser: User): Observable<User> {
    return this.http.put<User>(`${this.apiUrl}/Users/${newUser.id}`, newUser);
  }

  updateUserLastLogin(userId: number): Observable<User> {
    return this.http.patch<User>(
      `${this.apiUrl}/Users/${userId}/last-login`,
      {},
    );
  }

  deleteUser(id: string) {
    return this.http.delete(`${this.apiUrl}/Users/${id}`);
  }

  getOrganizations(searchParams: string) {
    let params = new HttpParams()
      .set('search', searchParams);
    return this.http.get<Organization[]>(`${this.apiUrl}/Organization`, { params: params })
  }


  validateUserEmail(email: string): Observable<boolean> {
    let params = new HttpParams().set("emailAddress", email);
    return this.http.get<boolean>(`${this.apiUrl}/Users/validateEmail`, {
      params: params,
    });
  }

  resetPassword(userId: string): Observable<any> {
    let params = {
      userId: userId,
    };
    return this.http.post<boolean>(
      `${this.apiUrl}/Users/ResetUserPassword`,
      params,
    );
  }

  constructor(private http: HttpClient) {}
}
